"use client";

import { useAidaStore } from "@/components/providers/stores/AidaStoreProvider";
import { Icon } from "@iconify/react";
import { memo } from "react";
import trackPxEvent from "@/utils/mixpanel";
import useSession from "@/hooks/useSession";
import { useAidaOffsets } from "@/hooks/useAidaSpacing";
import { useCrmView } from "@/hooks/useCrmView";
export const AidaButton = memo(() => {
  const isOpen = useAidaStore(state => state.isOpen);
  const toggleChat = useAidaStore(state => state.toggleChat);
  const session = useSession();
  const offsets = useAidaOffsets();
  const {
    isCrmView
  } = useCrmView();
  if (isOpen || isCrmView) return null;
  return <button data-testid="aida-button" onClick={() => {
    toggleChat();
    trackPxEvent({
      event: "ASSISTANT_CLICKED",
      email: session?.email ?? "",
      currentUrl: window.location.href
    });
  }} className="group bg-linear-to-r from-blue-500 to-purple-600 text-white focus:ring-purple-200 rounded-full flex flex-row items-center cursor-pointer transition-all duration-200 ease-in-out fixed z-50 p-3" style={{
    right: `${offsets.right}px`,
    bottom: `${offsets.bottom}px`
  }}>
      <span className="text-sm font-medium whitespace-nowrap transition-all duration-200 ease-in-out overflow-hidden max-w-0 opacity-0 group-hover:max-w-[120px] group-hover:opacity-100 group-hover:mr-2">
        Ask Aida
      </span>
      <Icon icon="heroicons-solid:sparkles" className="h-6 w-6 shrink-0" />
    </button>;
});
AidaButton.displayName = "AidaButton";